import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { details } from '../constants'
import DetailCard from './DetailCard'

class OverviewSection extends Component {
  render() {
    return (
      <div className="mt5 mt6-ns mb5 ml3 mr3">
        <div className="w-100 default-color b tc f2-ns f3 mb5-ns">
          <FormattedMessage id="overview.title" />
        </div>
        <div className="flex left-0 right-0 items-center items-start mt4-ns flex-column flex-row-ns">
          {
            Object.keys(details).map(key => {
              return (
                <DetailCard
                  key={key}
                  detail={key}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}

export default OverviewSection



// WEBPACK FOOTER //
// ./src/components/OverviewSection.js